const Manage = () => import('@pages/bind/Manage')
const PatientShow = () => import('@pages/bind/Manage/Show')
const PatientEdit = () => import('@pages/bind/Manage/Edit')
const PatientBind = () => import('@pages/bind/Manage/Bind')
const PatientCreate = () => import('@pages/bind/Manage/Create')
const PatientUnBind = () => import('@pages/bind/Manage/Unbind')

export const bind = [
  {
    path: '/bind/manage',
    name: 'BindManage',
    component: Manage,
    meta: {}
  },
  {
    path: '/bind/show/:id',
    name: 'PatientShow',
    component: PatientShow,
    meta: {}
  },
  {
    path: '/bind/edit/:id',
    name: 'PatientEdit',
    component: PatientEdit,
    meta: {}
  },
  {
    path: '/bind/bind',
    name: 'PatientBind',
    component: PatientBind,
    meta: {}
  },
  {
    path: '/bind/store',
    name: 'PatientCreate',
    component: PatientCreate,
    meta: {}
  },
  {
    path: '/bind/unbind',
    name: 'PatientUnBind',
    component: PatientUnBind,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/bind.route.js